import { useEffect, useRef, useState } from "react";
import { Play, Pause, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Tap-to-hear button: `load()` returns an /api audio path, fetched on first tap.
export default function PlayVoice({ load, label, testId }) {
  const [state, setState] = useState("idle");
  const a = useRef(null);
  useEffect(() => () => a.current?.pause(), []);
  const tap = async () => {
    if (state === "playing") { a.current.pause(); setState("idle"); return; }
    const el = a.current || new Audio(); a.current = el;
    el.onended = () => setState("idle");
    setState("loading");
    el.play().catch(() => {});
    try {
      if (!el.dataset.ready) { el.src = `${process.env.REACT_APP_BACKEND_URL}${await load()}`; el.dataset.ready = "1"; }
      el.currentTime = 0; await el.play(); setState("playing");
    } catch { setState("idle"); toast.error("Couldn't play the voice just now."); }
  };
  return (
    <button onClick={tap} disabled={state === "loading"} aria-label={label} data-testid={testId}
      className="shrink-0 w-10 h-10 rounded-full bg-primary/15 text-primary flex items-center justify-center hover:bg-primary/25 transition-colors mt-0.5">
      {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : state === "playing" ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4 ml-0.5" />}
    </button>
  );
}
